import { createSelector } from '@reduxjs/toolkit';
import { caseAttributesHelpers } from 'src/components/pages/Case/helpers';
import { selectCurrentUser } from 'src/selectors/selectCurrentUser';
import { TRootState } from 'src/store';
import { calculateCaseDates } from 'src/utils/case';

export const caseDatesPanel = createSelector(
  (state: TRootState) => state.case.caseById,
  selectCurrentUser,
  (caseById, currentUser) => {
    if (!caseById)
      return {
        caseId: '',
        selectedCategories: [],
        activeCategories: [],
        permissions: {},
      };

    const {
      isManualIntakeReport,
      submittedAt,
      companyCreatedAt,
      readAt,
      investigatingAt,
      closedAt,
    } = caseAttributesHelpers(caseById, currentUser);

    const companyCreatedAtDate = companyCreatedAt
      ? new Date(companyCreatedAt)
      : null;

    const readAtDate = readAt ? new Date(readAt) : null;
    const investigatingAtDate = investigatingAt
      ? new Date(investigatingAt)
      : null;
    const closedAtDate = closedAt ? new Date(closedAt) : null;
    const submittedAtDate = submittedAt ? new Date(submittedAt) : null;

    const datesWithLimits = calculateCaseDates({
      submittedAt: submittedAtDate,
      companyCreatedAt: companyCreatedAtDate,
      readAt: readAtDate,
      investigatingAt: investigatingAtDate,
      closedAt: closedAtDate,
    });

    const { canEditCaseClosedDate, canEditCaseCriDates, canEditCaseDetails } =
      caseById.AssociatedPermissions ?? {};

    return {
      caseId: caseById.id,
      canEditCreatedAtDate:
        canEditCaseDetails && canEditCaseCriDates && isManualIntakeReport,
      canEditReadAtDate:
        canEditCaseDetails && canEditCaseCriDates && isManualIntakeReport,
      canEditInvestigatingAtDate:
        canEditCaseDetails && canEditCaseCriDates && isManualIntakeReport,
      canEditClosedAtDate:
        canEditCaseDetails && (canEditCaseClosedDate || canEditCaseCriDates),
      companyCreatedAt: datesWithLimits.companyCreatedAt.value,
      companyCreatedAtMax: datesWithLimits.companyCreatedAt.max,
      companyCreatedAtMin: datesWithLimits.companyCreatedAt.min,
      readAt: datesWithLimits.readAt.value,
      readAtMax: datesWithLimits.readAt.max,
      readAtMin: datesWithLimits.readAt.min,
      investigatingAt: datesWithLimits.investigatingAt.value,
      investigatingAtMax: datesWithLimits.investigatingAt.max,
      investigatingAtMin: datesWithLimits.investigatingAt.min,
      closedAt: datesWithLimits.closedAt.value,
      closedAtMax: datesWithLimits.closedAt.max,
      closedAtMin: datesWithLimits.closedAt.min,
    };
  },
);
